import React, { Component } from 'react';
import BaseModal from '../BaseModal';

import styles from './styles.module.scss';
import Spinner from 'components/Spinner';

class SetUpcomingPlan extends Component {
  state = {
    loaderCounter: 0,
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { planName, changeField } = this.props;
    if (prevProps.planName && prevProps.planName !== planName) {
      changeField('plan', 'plan_price', '');
    }

    if (!prevProps.isOpen && this.props.isOpen) {
      this.loadData();
    }
  }

  handleSubmit = (values) => {
    const { fetchUpcomingPlan, setUpcomingPlan, subId, isQuick } = this.props;
    return setUpcomingPlan(subId, values).then(() => {
      if (!isQuick) {
        return fetchUpcomingPlan(subId);
      }
    });
  };

  loadData = () => {
    const { fetchUpcomingPlan, fetchAllPlans, subId, isAtt, isOpen } =
      this.props;
    let loaderCounter = 0;

    if (isOpen) {
      if (subId && isAtt) {
        fetchUpcomingPlan(subId).finally(() => {
          this.setState((state) => ({
            ...state,
            loaderCounter: state.loaderCounter - 1,
          }));
        });
        loaderCounter += 1;
      }
      const params = { subscription_id: subId, is_upcoming: true };
      loaderCounter += 1;

      this.setState({ loaderCounter: loaderCounter });

      fetchAllPlans(params).finally(() => {
        this.setState((state) => ({
          ...state,
          loaderCounter: state.loaderCounter - 1,
        }));
      });
    }
  };

  render() {
    const {
      isOpen,
      closeModal,
      PlanForm,
      subId,
      sub,
      user,
      isSimo,
      plans,
      upcomingPlan = [],
      userCustomPlans,
      isReseller,
      isAdmin,
      isAtt,
      isQuick,
      showSplittedForm,
      ...props
    } = this.props;
    const { loaderCounter } = this.state;

    let injectedPlans = [].concat(plans);
    // att plan fix
    if (
      isAtt &&
      upcomingPlan &&
      upcomingPlan[0] &&
      !injectedPlans.find((plan) => plan.id === upcomingPlan[0].plan)
    ) {
      const oldPlan = plans.find((plan) => plan.id === upcomingPlan[0].plan);
      if (oldPlan) {
        injectedPlans.push({ ...oldPlan, hidePlan: true });
      }
    }

    if (!sub || !plans) {
      return (
        <BaseModal
          isOpen={isOpen}
          title="Set Upcoming Plan"
          onClose={closeModal}
          className={styles.modal}
          confirmBtnText=""
          cancelBtnText=""
        >
          Loading...
        </BaseModal>
      );
    }

    let initialValues = {};
    if (isSimo) {
      initialValues = {
        plan_id: (sub && sub.upcoming_plan && sub.upcoming_plan.id) || null,
      };
    } else if (isAtt || isQuick) {
      if (showSplittedForm) {
        const plan = injectedPlans.find(
          (plan) =>
            plan.id === upcomingPlan?.[0]?.plan ||
            plan.id === sub?.upcoming_plan?.id,
        );
        initialValues = {
          plan_name: plan && plan.name,
          plan_price: plan && plan.price,
          plan_lock:
            (upcomingPlan[0] && upcomingPlan[0].plan_lock) || sub?.plan_locked,
        };
      } else if (upcomingPlan[0]) {
        initialValues = {
          plan_id: upcomingPlan[0].plan,
          plan_lock: upcomingPlan[0].plan_lock || sub?.plan_locked,
        };
      }
    }

    if (!PlanForm) {
      return null;
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title="Set Upcoming Plan"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <PlanForm
          {...props}
          showLockCheckbox={!isSimo}
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          subId={subId}
          plans={injectedPlans}
          isSimo={isSimo}
          isQuick={isQuick}
          isModal={true}
        />
        <Spinner showLoader={loaderCounter !== 0} />
      </BaseModal>
    );
  }
}

export default SetUpcomingPlan;
